<template>
  <div>
    <Navbar></Navbar>
    <div class="section_1">
      <div class="content-box">
        <div class="title">Lighter is better</div>
        <a class="smart" href="#section_3">Learn how light the Heart Smart<span style="font-size: 18px;">™</span> monitor is</a>
      <!-- <img src="@/assets/2.0/section_1_bg.png" /> -->
      </div>
    </div>
    <div class="section_2 d-flex align-center">
      <div class="content-box d-flex align-center justify-space-between">
        <div class="text-info">
          <div class="heart">Heart Smart™ for You</div>
          <div class="info">
            <p>·Exceptional detection accuracy</p>
            <p>·Light and comfort design</p>
            <p>·Secure and fast data intelligence</p>
          </div>
        </div>

        <div class="img-info">
          <img src="@/assets/2.0/icon_04.png" />
        </div>
      </div>
    </div>
    <div class="section_3" id="section_3">
      <div class="trait-list">
        <div class="trait-item">
          <div class="circle">1</div>
          <div class="title-text">Connect it</div>
          <div class="info-text">
            <p>Connect the monitor</p>
            <p>to cell phone</p>
          </div>
          <div class="img-info"><img src="@/assets/2.0/icon-01.svg" /></div>
        </div>
        <div class="trait-item">
          <div class="circle">2</div>
          <div class="title-text">Wear it</div>
          <div class="info-text">
            <p>Wear the monitor patch</p>
            <p>to your chest</p>
          </div>
          <div class="img-info">
            <img src="@/assets/2.0/icon-03.svg" />
          </div>
        </div>
        <div class="trait-item ">
          <div class="circle">3</div>
          <div class="title-text">Use it</div>
          <div class="info-text">
            <p>Monitor your heart and</p>
            <p>stress at anytime</p>
          </div>
          <div class="img-info"><img src="@/assets/2.0/icon-02.svg" /></div>
        </div>
      </div>
    </div>
    <div class="section_4">
      <div class="title">Lightest heart monitor with superior accuracy</div>
      <div class="info">We provide you three benefits only available with Heart Smart<span style="font-size: 18px;">™</span></div>
      <div class="table-list">
        <img src="@/assets/2.0/icon_group.png" />
      </div>
      <div class="table-img"><img src="@/assets/2.0/table-1.png" /></div>
    </div>
    <div class="section_6">
      <div class="content-box">
        <div class="title">
        <p>Smallest and lightest ECG </p>
        <p>ever seen and it will renovate</p>
        <p>patient experience.</p>
      </div>
      </div>

    </div>
    <div class="section_5">
      <div class="content-box">
        <div class="title">
        <p>I can't feel it and</p>
        <p>it works.</p>
      </div>
      </div>
    </div>
    <FooterDom></FooterDom>
  </div>
</template>

<script>
import Navbar from "./components/navbar.vue";
import FooterDom from "./components/footerEle.vue";

export default {
  name: "index",
  components: {
    Navbar,
    FooterDom
  },
  data() {
    return {

    };
  },
  computed: {

  },
  mounted() {

  },
  methods: {
    go(path) {
      this.$router.push(path)
    }
  }
};
</script>

<style lang="less" scoped>
.content-box{
  max-width: 1920px;
  width: 100%;
  height: 100%;
  margin: 0 auto;
}
.section_1{
  width: 100%;
  height: 946px;
  background: url("../../assets/2.0/section_1_bg.png") no-repeat;
  background-size: cover;
  background-position: center;
  img{
    width: 100%;
  }
  .title{
    width: 425px;
    font-size: 106px;
    color: #000;
    padding-top: 221px;
    margin-left: 276px;
    font-weight: 200;
    font-family: "Thin";
  }
  .smart{
    display:block;
    margin-left: 276px;
    width: fit-content;
    border: 1px solid #4FC78B;
    border-radius: 24px;
    font-size: 22px;
    color: #000;
    margin-top: 20px;
    padding:15px 30px;
    transition: all 0.2s;
    cursor: pointer;
    &:hover{
      background: #4FC78B;
      color: #fff;
    }
  }
}
.section_2{
  width: 100%;
  height: 772px;
  background: url("../../assets/2.0/section_2_bg.png") no-repeat;
  background-size: cover;
  .text-info{
    margin-left: 276px;
    width: 490px;
  }
  .img-info{
    margin-right: 276px;
  }
  .heart{
    position: relative;

    font-size: 80px;
    color:#000;
    font-family: "Thin";
  }
  .info{
    font-size: 24px;
    color:#000;
    line-height: 50px;
    margin-top: 20px;
  }
  .img-info{
    width: 733px;
    img{
      width: 100%;
    }
  }
}
.section_3{
  width: 100%;
  height: 828px;
  background: #efefef;
  .trait-list{
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #000;

    .trait-item{
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding: 0 120px;
      position: relative;
      &::after{
        content: "";
        width: 1px;
        height: 140px;
        position: absolute;
        top: 41%;
        right: 0;
        margin-top: -70px;
        border-right: 0.5px solid #000;
      }
      &:last-child{
        &::after{
          display: none;
        }
        padding: 0 0 0 120px;
      }
      &:first-child{
        padding: 0 120px 0 0;
      }
    }
    .circle{
      width: 65px;
      height: 65px;
      border-radius: 65px;
      border: 1px solid #000;
      font-size: 42px;
      text-align: center;
      line-height: 65px;
    }
    .title-text{
      font-size: 50px;
      margin-top: 60px;
      font-family: "Light";
    }
    .info-text{
      font-size: 24px;
      margin-top: 30px;
      p{
        text-align: center;
      }
    }
    .img-info{
      height: 102px;
      margin-top: 120px;
      img{
        height: 100%;
      }
    }
  }
}
.section_4{
  width: 100%;
  height: 909px;
  .title{
    margin-top: 67px;
    font-size: 60px;
    width: 100%;
    text-align: center;
  }
  .info{
    margin-top: 20px;
    font-size: 20px;
    width: 100%;
    text-align: center;
  }
  .table-list{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 60px;
    img{
      width: 906px;
    }

  }
  .table-img{
      width: 843px;
      margin: 140px auto 0 auto;
      img{
        width: 100%;
      }
    }
}
.section_5{
  width: 100%;
  position: relative;
  height: 837px;
  background: url("../../assets/2.0/section_5_bg.png") no-repeat;
  background-size: cover;
  background-position: center;
  .title{
    color: #000;
    font-size: 90px;
    margin-left: 276px;
    padding-top: 120px;
  }
}
.section_6{
  width: 100%;
  height: 835px;
  position: relative;
  background: url("../../assets/2.0/section_6_bg.png") no-repeat;
  background-size: cover;
  background-position: center;
  .title{
    color: #000;
    font-size: 50px;
    margin-left: 276px;
    padding-top: 160px;
    line-height: 90px;
  }
}
.bg-img{
    width: 100%;
    img{
      width: 100%;
    }
  }


/* 桌面显示器，小于 1600px） */
@media (max-width: 1600px) {
  .section_1{
    .title{
    font-size: 82px;
  }
    .smart{
      font-size: 14px;
      padding: 5px 15px;
    }
  }
  .section_2{
    .heart{
    font-size: 48px;
    }
    .info{
      font-size: 18px;
    }
  }
  .section_3{
      .trait-list{
      .title-text {
        font-size: 40px;
        margin-top: 40px;
      }
      .info-text {
        font-size: 20px;
        margin-top: 20px;
      }
      .trait-item{
        padding: 0 80px;
        &:last-child{
         padding: 0 0 0 80px;
        }
        &:first-child{
          padding: 0 80px 0 0;
        }
      }
      .img-info{
        margin-top: 80px;
      }
    }
  }
}

/* 桌面显示器，小于 1400px） */
@media (max-width: 1400px) {
  .section_2{
    .heart{
    font-size: 40px;
    }
    .info{
      font-size: 16px;
    }
  }
  .section_5{
    .title{
      font-size: 70px;
    }
  }
  .section_6{
    .title{
      font-size: 38px;
    }
  }
}

/* 桌面显示器，小于 1200px） */
@media (max-width: 1200px) {
  .section_1{
    .title{
    font-size: 82px;
    margin-left: 66px;
  }
    .smart{
      font-size: 14px;
      padding: 5px 15px;
      margin-left: 66px;
    }
  }
  .section_2{
    .text-info{
    margin-left: 66px;
    width: 490px;
  }
  .img-info{
    margin-right: 66px;
  }
    .heart{
    //font-size: 60px;
    }
    .info{
      //font-size: 20px;
    }
  }
  .section_3{
      .trait-list{
      .title-text {
        font-size: 40px;
        margin-top: 40px;
      }
      .info-text {
        font-size: 20px;
        margin-top: 20px;
      }
      .trait-item{
        padding: 0 80px;
        &:last-child{
         padding: 0 0 0 80px;
        }
        &:first-child{
          padding: 0 80px 0 0;
        }
      }
      .img-info{
        margin-top: 80px;
      }
    }
  }

  .section_5{
    .title{
      font-size: 70px;
      margin-left: 66px;
    }
  }
  .section_6{
    .title{
      font-size: 38px;
      margin-left: 66px;
      padding-top: 120px;
    }
  }
}

/* 桌面显示器，小于 992px） */
@media (max-width: 992px) {
  .section_1{
    .title{
    font-size: 66px;
    padding-top: 201px;
  }
    .smart{
      margin-top: 10px;
      padding: 5px 15px;
    }
  }
  .section_2{
    .heart{
    font-size: 50px;
  }
  .info{
    font-size: 16px;
  }
  }
  .section_3{
    height: auto;
    padding: 60px 0;
      .trait-list{

        flex-direction: column;
      .title-text {
        font-size: 40px;
        margin-top: 40px;
      }
      .info-text {
        font-size: 20px;
        margin-top: 20px;
      }
      .trait-item{
        width: 50%;
        padding: 40px 0;
        &::after{
          content: "";
          width: 100%;
          height: auto;
          position: absolute;
          left: 0%;
          bottom: 0;
          border-bottom: 0.5px dashed #000;
          border-right: none;
        }
      &:last-child{
        &::after{
          display: none;
        }
        padding: 40px 0 0 0;
      }
        &:first-child{
          padding: 0 0px 40px 0;
        }
      }
    }
  }
  .section_4{
    .table-list{
      width: 85%;
      margin: 30px auto;
      img{
          width: 100%;
        }
    }
    .table-img{
        width: 90%;
        img{
          width: 100%;
        }
      }
  }
  .section_5{
    .title{
      font-size: 50px;
    }
  }
  .section_6{
    .title{
      font-size: 30px;
      line-height: 60px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/index.vue